module.exports = __webpack_public_path__ + "img/header-diamondJewelryGold.75b2748.webp";